import {Injectable} from '@angular/core';
import {
    AbstractFindManyPaginatedService
} from '../../../../core/service/v2/service/findmany/abstractFindManyPaginated.service';
import {DocumentModel} from '../model/document.model';
import {DocumentRepository} from '../../impl/service/ngrx/document.repository';
import {DocumentDataServiceAdapter} from '../../impl/service/ngrx/documentDataService.adapter';
import {Operator, UrlParameter} from "../../../../../shared/utils/url.builder";

@Injectable()
export class DocumentStickyPaginatedService extends AbstractFindManyPaginatedService<DocumentModel, DocumentModel> {

    public constructor(repository: DocumentRepository, dataServiceAdapter: DocumentDataServiceAdapter) {
        super(repository, dataServiceAdapter, [new UrlParameter('sticky', true, Operator.EQUALS)]);
    }
}
